import React from "react";
import "./checkbox.css";

const CheckboxField = ({
	field,
	value,
	onChange
}) => {
	const handleChange = event => {
		onChange(field.name, event.target.checked);
	};

	return (
		<label
			className="form-generic__checkbox-field"
			htmlFor={field.id || field.name}
		>
			<input
				id={field.id || field.name}
				type="checkbox"
				name={field.name}
				checked={Boolean(value)}
				onChange={handleChange}
				disabled={field.disabled}
			/>

			<span>{field.label}</span>
		</label>
	);
};

export default CheckboxField;